// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"2275578acf95c0a8f9c0","678":"de9354181ee0be4120ca","883":"333f886bff06481fcf41"}[chunkId] + ".js";
};